const SECRET_KEYS =
	"password|passcode|pin|token|refreshToken|accessToken|staffToken|secret|authorization";

const REDACTED = "[redacted]";

// `"key":"value"` and `"key":123`, plus the same pair JSON-escaped inside
// another string (`\"key\":\"value\"`), e.g. an error message that embeds a
// serialized GraphQL request with its variables.
const PATTERNS: [RegExp, string][] = [
	[
		new RegExp(`("(?:${SECRET_KEYS})"\\s*:\\s*")[^"]*(")`, "gi"),
		`$1${REDACTED}$2`,
	],
	[
		new RegExp(`("(?:${SECRET_KEYS})"\\s*:\\s*)-?\\d+`, "gi"),
		`$1"${REDACTED}"`,
	],
	[
		new RegExp(
			`(\\\\"(?:${SECRET_KEYS})\\\\"\\s*:\\s*\\\\")(?:[^\\\\]|\\\\(?!"))*(\\\\")`,
			"gi",
		),
		`$1${REDACTED}$2`,
	],
];

/** Masks secret-looking JSON fields (passwords, PINs, tokens) in free text. */
export function redactSecrets(text: string): string;
export function redactSecrets(text: string | undefined): string | undefined;
export function redactSecrets(text: string | undefined) {
	if (text === undefined) return text;
	return PATTERNS.reduce(
		(result, [pattern, replacement]) => result.replace(pattern, replacement),
		text,
	);
}
